import { Card, Group, SimpleGrid, Text } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import BadgeStatus from '../../components/elements/BadgeStatus';
import ErrorHandler from '../../components/elements/ErrorHandler';
import IconMap from '../../components/icons/IconMap';
import { AppContext } from '../../contexts';
import { fetchMerchantRegistrationDetail } from './actions';
// import { fetchMerchantRegistrationDetail } from './actions';
import Button from '../../components/elements/Button';
import ModalMap from '../../components/fragments/ModalMap';
import IcMap from '../../components/icons/IcMap';
import styles from './styles.scoped.css';

export default function DetailVerfication() {
  const { id, type } = useParams();

  const { setBreadcrumbs } = useContext(AppContext);
  const [showMap, setShowMap] = useState(false);
  const dispatch = useDispatch();

  const {
    dataMerchantRegistrationDetail: data,
    isLoadingMerchantRegistrationDetail,
    messageMerchantRegistrationDetail,
  } = useSelector((s) => s.merchantRegistrations);

  const centerPoint = {
    lat: parseFloat(data?.coordinate?.split(',')[0]),
    lng: parseFloat(data?.coordinate?.split(',')[1])
  };
  // const [approveDialogVisible, setApproveDialogVisible] = useState(false);
  // const [rejectDialogVisible, setRejectDialogVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchMerchantRegistrationDetail(id, type));
  }, []);

  useEffect(() => {
    setBreadcrumbs(['Registrasi Pangkalan LPG 3 Kg']);
  }, []);

  if (isLoadingMerchantRegistrationDetail) {
    return null;
  }

  if (messageMerchantRegistrationDetail) {
    return <ErrorHandler message={messageMerchantRegistrationDetail} />;
  }

  const renderInfo = (label, data) => (
    <SimpleGrid cols={2}>
      <div className={styles.label}>{label}</div>
      <div>: {data}</div>
    </SimpleGrid>
  );

  const renderReason = (reasons) => {
    return (
      <ul>{reasons.map((reason, index) => (
        <li key={index}>{reason}</li>
      ))}</ul>
    );
  };

  return (
    <div>
      <Card key={data.registrationId} radius="md"  withBorder >
        <Card.Section inheritPadding py="xs" withBorder>
          <Text fz={24} weight={700}>{data.storeName}</Text>
        </Card.Section>
        <Card.Section inheritPadding py="xs">
          <Text fz={20} weight={700}>Data Pangkalan LPG 3 Kg</Text>
        </Card.Section>
        <SimpleGrid  cols={2}>
          <div>
            {renderInfo('Tanggal Registrasi', data.registrationDate)}
            {renderInfo('Jam Registrasi', data.registrationTime)}
            {renderInfo('ID Registrasi', data.registrationId || '-')}
            {renderInfo('ID Agen', `${data?.agen?.id} - ${data?.agen?.name}`)}
            {renderInfo('Wave', data.wave)}
            {renderInfo('MID', data.midMap)}
          </div>
          <div>
            {renderInfo('MID LinkAja', data.midLA === 'aplikasi_mypertamina' || data.midLA === undefined || data.midLA === null ?
              <BadgeStatus label={'Belum Aktivasi'}/> : data.midLA)}
            {renderInfo('Nama Pemilik', data.ownerName)}
            {renderInfo('No. KTP Pemilik', data.nationalityId)}
            {renderInfo('No. Ponsel Pemilik', data.phoneNumber)}
            {renderInfo('No. Telepon Pangkalan LPG 3 Kg', data.storePhoneNumber)}
            {renderInfo('Email Pemilik', data.email)}
          </div>
        </SimpleGrid>

        <Card.Section className={styles.lineCard} inheritPadding py="xs" >
          <Text fz={20} weight={700}>Alamat Pangkalan LPG 3 Kg</Text>
        </Card.Section>
        <SimpleGrid  cols={2}>
          <div>
            {renderInfo('Provinsi', data.provinceName)}
            {renderInfo('Kota/Kabupaten', data.cityName)}
            {renderInfo('Kecamatan', data.districtName)}
            {renderInfo('Kelurahan', data.villageName)}
          </div>
          <div>
            {renderInfo('Kode Pos', data.zipcode || data.zipCode)}
            {renderInfo('Alamat', data.street)}
          </div>
        </SimpleGrid>
      </Card>

      {type === 'failed' ?
        <Card mt={24} radius="md">
          <SimpleGrid cols={3}>
            <div>
              <Text fz={16} weight={400}>Status</Text>
              <BadgeStatus label={data.status}/>
            </div>
            <div style={{ borderLeft: '1px solid #cccccc', borderRight: '1px solid #cccccc', padding: '0 16px' }}>
              <Text fz={16} weight={400}>Petinjau</Text>
              <Text fz={16} weight={700}>{data.reviewer === '' ? '-' : data.reviewer}</Text>
            </div>
            <div>
              <Text fz={16} weight={400}>Alasan</Text>
              <Text fz={16} weight={500}>
                {data?.reasons !== undefined && renderReason(data?.reasons)}
              </Text>
            </div>
          </SimpleGrid>
        </Card>
        :
        <Card mt={24} radius="md">
          <Text fz={16} weight={400}>Petinjau</Text>
          <Text fz={16} weight={700}>{data.reviewer === '' ? '-' : data.reviewer}</Text>
        </Card>
      }
      <Card mt={24} radius="md" withBorder>
        <Card.Section inheritPadding py="xs" withBorder>
          <Group position="apart">
            <Text weight={500}>Titik Koordinat</Text>
            <Text>{data.coordinate}</Text>
          </Group>
        </Card.Section>
        <div className={styles.mapContainer}>
          <IconMap />
          <Button className={styles.btnShowMap} onClick={() => setShowMap(true)} outlined>
            <IcMap /> Tampilkan Map
          </Button>
        </div>
      </Card>
      <ModalMap centerPoint={centerPoint} setShowMap={setShowMap} showMap={showMap} />
    </div>
  );
}
